import { render, staticRenderFns } from "./PreStart.vue?vue&type=template&id=4ae7d5ae&"
import script from "./PreStart.vue?vue&type=script&lang=js&"
export * from "./PreStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports